class SectionCompanyInfo implements ng.IComponentController {
    ltTitle: string;
    title2: string;
    description: string;
    logoUrl: string;
    background: anm.LandingBackground;
    list: anm.IconTextListItem[];
}

angular.module('animatronApp.sectionCompanyInfo', []).component('sectionCompanyInfo', {
    bindings: {
        ltTitle: '<',
        title2: '<',
        logoUrl: '<',
        description: '<',
        background: '<',
        list: '<',
    },
    controller: SectionCompanyInfo,
    templateUrl: require('landing-template/components/sections/section-company-info.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionCompanyInfo.ts